<template lang="pug">
section.statistic-panel.v-container.grid-list-md
  template(v-if="estadisticas && estadisticas.poblacion")
    .ver-mas.layout.row.justify-end
      span.align-self-center Para ver más datos haga click aquí
      a.download-button.md-elevation-4(:style="getBackgroundColorPropertyStyle(color)" target="_blank" :href="sheetLink")
          i.material-icons link
    template(v-if="!estadisticas.poblacion || !estadisticas.poblacion.total || estadisticas.poblacion.total === -1")
      .empty-data-text.poblacion Dentro del área seleccionada no se encuentra vivienda alguna según datos de la Dirección General de Estadísticas, Encuestas y Censos (DGEEC) del año 2012
    template(v-else)
      .source-data-text
        strong Fuente:
        div - Secretaría Técnica de Planificación (STP)
        div - Dirección General de Estadísticas, Encuestas y Censos (DGEEC): Censo Nacional de Población y Vivienda, 2012.
      .asu-title-1(:style="getColorPropertyStyle({ color: color })") POBLACIÓN TOTAL
      .statistics.population.layout.row.wrap.align-center
        .flex.xs3.sm2.offset-xs3.offset-sm0
          i.ap-population(:style="getColorPropertyStyle({ color: color })")
        span.total.flex.xs6.sm2(:class="'decimalPlace-' + decimalPlace(estadisticas.poblacion.total)") {{format(estadisticas.poblacion.total)}}
        .flex.xs2.sm1.offset-sm1
          i.ap-men(:style="getColorPropertyStyle({ color: color })")
        span.flex.xs4.sm2.population-gender
          div Hombres
          div.percentage {{format(estadisticas.poblacion.hombres)}}%
        .flex.xs2.sm1.offset-sm1
          i.ap-woman(:style="getColorPropertyStyle({ color: color })")
        span.flex.xs4.sm2.population-gender
          div Mujeres
          div.percentage {{format(estadisticas.poblacion.mujeres)}}%
      .asu-title-2.mt-20(:style="getColorPropertyStyle({ color: color })") Población por grupo de edad
      StatisticAgePanel(:color="color" :code="code" :estadisticas="parseFloatDeep(estadisticas.poblacion)")
      .asu-title-2(:style="getColorPropertyStyle({ color: color })") Categoría de ocupación de población ocupada
      .statistics.workers.layout.row
        i.icon.ap-occupation.flex.xs3.align-self-center(:style="getColorPropertyStyle({ color: color })")
        StatisticWorkersPanel.flex.xs9(:color="color" :code="code" :estadisticas="parseFloatDeep(estadisticas.ocupacion)")
      .asu-title-3(:style="getBackgroundColorPropertyStyle(color)") Datos de viviendas particulares
      .statistics.living-place
        .layout.row.row-1
          .flex.xs4.align-self-center
            .ap-living-place(:style="getColorPropertyStyle({ color: color })" :class="'decimalPlace-' + decimalPlace(estadisticas.viviendas.total)")
              span {{format(estadisticas.viviendas.total)}}
          .flex.xs8.align-self-stretch.text(:style="'border-left-color:' + color + ';' ")
            | Viviendas particulares ocupadas con personas presentes
        .asu-title-2.mt-20.mb-20(:style="getColorPropertyStyle({ color: color })") Acceso a TIC (Tecnología de la Información y Comunicación)
        .layout.row.row-2
          .flex.xs3
            i.icon.ap-phone
            div.legend Teléfono fijo
            div {{format(estadisticas.viviendas.conAccesoA.telefono)}}%
          .flex.xs3
            i.icon.ap-cell-phone
            div.legend Teléfono celular
            div {{format(estadisticas.viviendas.conAccesoA.celular)}}%
          .flex.xs3
            i.icon.ap-computer
            div.legend Computadora
            div {{format(estadisticas.viviendas.conAccesoA.computadora)}}%
          .flex.xs3
            i.icon.ap-internet
            div.legend Internet
            div {{format(estadisticas.viviendas.conAccesoA.internet)}}%
        .asu-title-2.mt-20(:style="getColorPropertyStyle({ color: color })") Condición de propiedad de vivienda
        .layout.row.row-3
          i.icon.ap-housing-condition.flex.xs4.align-self-center(:style="getColorPropertyStyle({ color: color })")
          StatisticLivingPlacePanel.flex.xs8(:color="color" :code="code" :estadisticas="parseFloatDeep(estadisticas.viviendas.condicion)")
  template(v-else)
    .asu-title No hay datos estadísticos para este proyecto

</template>

<script>
import colorPropertyMixin from '@/mixins/color-property.js'
import { parseFloatDeep } from '@/utils/form.js'

export default {
  name: 'StatisticPanel',
  mixins: [colorPropertyMixin],
  components: {
    StatisticAgePanel: _ => import('./StatisticAgePanel'),
    StatisticLivingPlacePanel: _ => import('./StatisticLivingPlacePanel'),
    StatisticWorkersPanel: _ => import('./StatisticWorkersPanel')
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    estadisticas: Object
  },
  data () {
    return {
      sheetLink: 'http://bit.ly/AsuParticipaStats1'
    }
  },
  methods: {
    parseFloatDeep,
    decimalPlace (number) {
      return number ? number.toString().length : 3
    },
    format (value) {
      return value >= 0 ? value : '-'
    }
  }
}
</script>

<style scope lang="stylus">
@import '~@/styles/variables'

$download-button-size = $f40px

.statistic-panel
  color: $gray_color
.ver-mas
  font-size: $f16px
  a.download-button
    margin-left: $f10px
.download-button
  width: $download-button-size
  height: $download-button-size
  border-radius: 50%
  i.material-icons
    min-width: $download-button-size
.asu-title-1
  font-size: $f20px;
  font-weight: bold
  margin-top: $f7px
.statistics
  .legend
    @media screen and (max-width: 450px)
      font-size: $f15px
  i
    font-size: $f50px
    &.ap-men
      font-size: $f40px
    &.icon
      font-size: $f90px
      color: $gray_color
      @media screen and (max-width: 450px)
        font-size: $f60px
    &.ap-population
      font-size: $f80px
      height: $f15px
    &.ap-men
      @media screen and (max-width: 450px)
        font-size: $f40px
    &.ap-occupation
      font-size: $f100px
      @media screen and (max-width: 450px)
        font-size: $f75px
    &.ap-housing-condition
      font-size: $f120px
      @media screen and (max-width: 450px)
        font-size: $f90px
  &.population
    div
      line-height: 1
    .total
      font-size: $f50px
      font-weight: bold
      line-height: 1
      &.decimalPlace-4
        font-size: $f39px
      &.decimalPlace-5
        font-size: $f32px
      &.decimalPlace-6
        font-size: $f27px
    .percentage
      font-size: $f30px
      font-weight: bold
    .population-gender
      padding-left: $f2px
  &.living-place
    padding-top: $f10px
    .row-1
      align-items: end
    .ap-living-place
      font-size: $f110px
      position: relative
      &.decimalPlace-2 span
        left: $f30px
      &.decimalPlace-3 span
        left: $f17px
      &.decimalPlace-4 span
        font-size: $f35px
        left: $f20px
      &.decimalPlace-5 span
        font-size: $f30px
        left: $f17px
        bottom: $f25px
      span
        position: absolute
        font-size: $f50px
        font-weight: bold
        color: white
        left: $f42px
        bottom: $f18px
    .text
      line-height: 1
      border-left: $f3px solid white
      padding-top: $f20px
      padding-left: $f10px
    .row-2
      .flex
        text-align: center
.asu-title-2
  &.mt-20
    margin-top: $f20px
  &.mb-20
    margin-bottom: $f20px
.asu-title-3
  color: white
  display inline-block
  font-size: $f18px
  font-weight: bold
  margin-top: $f25px
  margin-left: - $f10px
  padding: $f1px $f20px
  text-transform: uppercase
</style>
